// src/utils/formatTextWithHighlight.tsx
import { ReactNode } from "react";

export const formatTextWithHighlight = (
  text: string,
  highlightColor: string
): ReactNode[] => {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);

  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return (
        <strong key={index} style={{ color: highlightColor }}>
          {part.replace(/\*\*/g, "")}
        </strong>
      );
    }
    return <span key={index}>{part}</span>;
  });
};
